import React, { Component, createRef } from 'react';

import ComparisonHelper from '../../../utils/ComparisonHelper';
import ModalMaxUpfrontSlider from './ModalMaxUpfrontSlider';
import ModalPrepaidExpirySlider from './ModalPrepaidExpirySlider';
import ModalSpendSlider from './ModalSpendSlider';

export default class AdvancedTab extends Component {
    constructor(props) {
        super(props);
        this.comparisonHelper = new ComparisonHelper();

        this.state = this.getState(this.props);

        this.wrapper = createRef();
        this.onCurrentlyWithChange = this.onCurrentlyWithChange.bind(this);
        this.onSortExpressionChange = this.onSortExpressionChange.bind(this);
        this.onPlanTypeChange = this.onPlanTypeChange.bind(this);
        this.onOtherOptionsChange = this.onOtherOptionsChange.bind(this);
    }

    componentDidMount() {
        this.initialiseJSControls();
        this.updateJSControls();
    }

    initialiseJSControls() {
        const dom = wo$(this.wrapper.current);

        let select = dom.find('#choose-currently-with');
        WhistleOut.applySelectPicker(select);
        select.on('change', this.onCurrentlyWithChange);

        select = dom.find('#sort-by');
        WhistleOut.applySelectPicker(select);
        select.on('change', this.onSortExpressionChange);

        select = dom.find('#plan-type');
        WhistleOut.applySelectPicker(select);
        select.on('change', this.onPlanTypeChange);

        select = dom.find('#choose-other-option');
        WhistleOut.applySelectPicker(select);
        select.on('change', this.onOtherOptionsChange);

        WhistleOut.applySelectPickersStyle(dom);
    }

    componentWillUnmount() {
        const dom = wo$(this.wrapper.current);

        let select = dom.find('#choose-currently-with');
        select.off('change', this.onCurrentlyWithChange);

        select = dom.find('#sort-by');
        select.off('change', this.onSortExpressionChange);

        select = dom.find('#plan-type');
        select.off('change', this.onPlanTypeChange);

        select = dom.find('#choose-other-option');
        select.off('change', this.onOtherOptionsChange);
    }

    componentDidUpdate() {
        this.updateJSControls();
    }

    getState(props) {
        const criteriaCommon = props.criteria.common;
        const otherOptions = [];
        if (props.criteria.compareUnthrottledData !== false && props.criteria.compareUnthrottledData !== 'false') {
            otherOptions.push('full-speed-data');
        }
        if (criteriaCommon.maxResultsPerSupplier === 1 || criteriaCommon.maxResultsPerSupplier === '1') {
            otherOptions.push('single-result');
        }
        if (
            criteriaCommon.includeOffersWithCampaignOnly !== false &&
            criteriaCommon.includeOffersWithCampaignOnly !== 'false'
        ) {
            otherOptions.push('deals-only');
        }

        return {
            currentSupplierShortUrl: criteriaCommon.currentSupplierShortUrl,
            resultsSortExpression: criteriaCommon.resultsSortExpression,
            resultsSortAscending: criteriaCommon.resultsSortAscending,
            planTypes: props.criteria.planTypes,
            otherOptions: otherOptions
        };
    }

    // TODO: Replace JS select with the react Shared/Select component and remove this
    updateJSControls() {
        const dom = wo$(this.wrapper.current);
        this.setCurrentlyWith(dom);
        this.setSortExpression(dom);
        this.setPlanType(dom);
        this.setOtherOptions(dom);
    }

    setCurrentlyWith(dom) {
        const select = dom.find('#choose-currently-with');
        select.selectpicker('val', this.state.currentSupplierShortUrl);
    }

    onCurrentlyWithChange(e) {
        const selectedValue = wo$(e.currentTarget).selectpicker('val');

        this.setState({ currentSupplierShortUrl: selectedValue });
        this.props.modalActions.changeCurrentSupplier(selectedValue);
    }

    setSortExpression(dom) {
        const select = dom.find('#sort-by');
        if (
            this.state.resultsSortExpression ||
            this.state.resultsSortAscending === true ||
            this.state.resultsSortAscending === false
        ) {
            let selectedValue = this.state.resultsSortExpression;
            if (this.state.resultsSortAscending === false) {
                selectedValue = `${selectedValue}-desc`;
            }
            select.selectpicker('val', selectedValue);
        }
    }

    onSortExpressionChange(e) {
        const selectedValue = wo$(e.currentTarget).selectpicker('val');
        let descending = false;
        let value = selectedValue;
        if (selectedValue.indexOf('-desc') >= 0) {
            descending = true;
            value = value.replace('-desc', '');
        }

        this.setState({
            resultsSortExpression: value,
            resultsSortAscending: !descending
        });

        this.props.modalActions.changeSortExpression(value, descending);
    }

    setPlanType(dom) {
        const select = dom.find('#plan-type');
        const planTypes = this.state.planTypes;
        if (planTypes && planTypes.length) {
            const selectedValue = planTypes[0];
            select.selectpicker('val', selectedValue);
        }
    }

    onPlanTypeChange(e) {
        const selectedValue = wo$(e.currentTarget).selectpicker('val');
        this.setState({ planTypes: [selectedValue] });
        this.props.modalActions.changePlanType(selectedValue);
    }

    setOtherOptions(dom) {
        const select = dom.find('#choose-other-option');
        select.selectpicker('val', this.state.otherOptions);
    }

    onOtherOptionsChange(e) {
        const selectedValues = wo$(e.currentTarget).selectpicker('val');
        this.setState({ otherOptions: selectedValues });
        this.props.modalActions.setOtherOptions(selectedValues);
    }

    render() {
        return (
            <div className="row" ref={this.wrapper}>
                <div className="col-md-10">
                    <div className="row">
                        <div className="col-xs-24 bor-b-1 pad-y-2 mar-b-4">
                            <h5 className="font-5"> {this.props.resources.priceFilters} </h5>
                        </div>
                    </div>
                    <ModalMaxUpfrontSlider
                        {...this.props.maxUpfrontSlider}
                        current={this.props.criteria.maximumTabletUpfrontCost}
                        actions={this.props.modalActions}
                    />
                    <ModalSpendSlider
                        resources={this.props.resources}
                        {...this.props.spendSlider}
                        maxValue={this.props.criteria.common.maximumSpend}
                        minValue={this.props.criteria.common.minimumSpend}
                        actions={this.props.modalActions}
                    />
                    <div className="row">
                        <div className="col-xs-24 bor-b-1 pad-y-2 mar-b-4">
                            <h5 className="font-5"> Prepaid</h5>
                        </div>
                    </div>
                    <ModalPrepaidExpirySlider
                        resources={this.props.resources}
                        {...this.props.prepaidExpirySlider}
                        maxValue={this.props.criteria.maximumPrepaidExpiryDays}
                        minValue={this.props.criteria.prepaidExpiryDays}
                        actions={this.props.modalActions}
                    />
                </div>
                <div className="col-sm-24 col-md-12 col-md-offset-2">
                    <div className="row">
                        <div className="col-xs-24 pad-t-2 hover-bg">
                            <h5 className="font-5"> Currently With </h5>
                        </div>
                    </div>
                    <div className="row bor-b-1 pad-b-4">
                        <div className="col-xs-24">
                            <div className="selectpicker-wide">
                                {
                                    // TODO: Replace with Shared/Select component
                                }
                                <select
                                    id="choose-currently-with"
                                    tabIndex={-1}
                                    className="selectpicker bs-select-hidden"
                                    data-live-search="true"
                                >
                                    {this.props.currentlyWithValues.map(currentlyWith => {
                                        return (
                                            <option key={currentlyWith.key} value={currentlyWith.key}>
                                                {currentlyWith.value}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-24 pad-t-2">
                            <h5 className="font-5"> Sort Results By </h5>
                        </div>
                    </div>
                    <div className="row bor-b-1 pad-b-4">
                        <div className="col-xs-24">
                            <div className="selectpicker-wide">
                                {
                                    // TODO: Replace with Shared/Select component
                                }
                                <select id="sort-by" tabIndex={-1} className="selectpicker bs-select-hidden">
                                    {this.props.sortExpressions.map(sortExpression => {
                                        return (
                                            <option key={sortExpression.key} value={sortExpression.key}>
                                                {sortExpression.value}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-24 pad-t-2">
                            <h5 className="font-5"> Plan Type </h5>
                        </div>
                    </div>
                    <div className="row bor-b-1 pad-b-4">
                        <div className="col-xs-24">
                            <div className="selectpicker-wide">
                                {
                                    // TODO: Replace with Shared/Select component
                                }
                                <select id="plan-type" tabIndex={-1} className="selectpicker bs-select-hidden">
                                    {this.props.planTypes.map(planType => {
                                        return (
                                            <option key={planType.key} value={planType.key}>
                                                {planType.value}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-24 pad-t-2">
                            <h5 className="font-5"> Other Options </h5>
                        </div>
                    </div>
                    <div className="row pad-b-4">
                        <div className="col-xs-24">
                            <div className="selectpicker-wide mar-b-2-xs mar-b-3-sm">
                                {
                                    // TODO: Replace with Shared/Select component
                                }
                                <select
                                    id="choose-other-option"
                                    tabIndex={-1}
                                    className="selectpicker bs-select-hidden"
                                    multiple
                                    data-selected-text-format="count>1"
                                    title={this.props.resources.selectOptions}
                                >
                                    {this.props.advancedOtherOptions.map(o => {
                                        return (
                                            <option key={o.key} value={o.key}>
                                                {o.value}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
